/* eslint-disable react/prefer-stateless-function */
import React, { useState, useEffect } from 'react';
import { useToasts } from 'react-toast-notifications';
import { useMutation, useQuery } from 'react-apollo';
import { useParams } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import CreateOffer from './CreateOffer';
import {
  handleGraphqlError, history, routeConstants, NUMERIC_VALUE, loaderStyle,
} from '../../../../utils';
import {
  CREATE_OFFER, EDIT_OFFER, LOADER_MUTATION, REMOVE_OFFER,
} from '../../../../graphql-client/mutations';
import { GET_OFFER_LIST_QUERY, GET_OFFER_DETAIL_QUERY, GET_BRANDS_CATEGORY_TAGS } from '../../../../graphql-client/queries';

function CreateOfferContainer() {
  const { addToast } = useToasts();
  const [apiData, setApiData] = useState();
  const { offerId } = useParams();
  const [queryObj] = useState({ offerId });

  const mutationToCall = offerId ? EDIT_OFFER : CREATE_OFFER;

  if (!offerId) {
    localStorage.removeItem('appliedOfferFilter');
  }

  const {
    loading, data: offerDetailData, refetch: getUserRefetch,
  } = useQuery(
    GET_OFFER_DETAIL_QUERY, {
      variables: queryObj,
      skip: !offerId,
    },
  );

  const {
    loading: categoryLoader, data: categoryData,
  } = useQuery(
    GET_BRANDS_CATEGORY_TAGS, {
      variables: { isCategory: true },
    },
  );

  useEffect(() => {
    if (offerId) {
      getUserRefetch();
    }
  },
  [offerId]);

  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: true },
  });
  const [removeOffer] = useMutation(REMOVE_OFFER, {
    variables: {},
    refetchQueries: [{
      query: GET_OFFER_LIST_QUERY,
      variables: { page: 1, limit: NUMERIC_VALUE.FIVE },
    }],

    onError(err) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(response) {
      loader({ variables: { show: false } });
      addToast(response.removeOffer.message, { appearance: 'success' });
      document.body.classList.remove('bg-grey');
      history.push(routeConstants.ADMIN_OFFER);
    },
  });

  const deleteOffer = () => {
    removeOffer({ variables: { offerId } });
  };

  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: true },
    refetchQueries: [{
      query: GET_OFFER_LIST_QUERY,
      variables: { page: 1, limit: NUMERIC_VALUE.FIVE },
    }],
  });

  const [createOffer] = useMutation(mutationToCall, {
    variables: apiData,
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(createOfferData) {
      loaderMutate({ variables: { show: false } });
      addToast(offerId ? createOfferData.editOffer.message : createOfferData.createOffer.message, { appearance: 'success' });
      document.body.classList.remove('bg-grey');
      history.push(routeConstants.ADMIN_OFFER);
    },

  });

  useEffect(() => {
    if (apiData) {
      createOffer();
    }
  }, [apiData]);

  const onSubmitCallBack = (offerData) => {
    setApiData(offerData);
    loaderMutate({ variables: { show: true } });
  };

  return (
    <>
      <LoadingOverlay
        active={loading || categoryLoader}
        spinner
        text=""
        className="containerLoader"
        styles={loaderStyle}
      >
        <CreateOffer
          submitCallBack={onSubmitCallBack}
          offerData={offerDetailData && offerDetailData.offerDetail && offerDetailData.offerDetail.data}
          categoryData={categoryData && categoryData.getCategoryTags && categoryData.getCategoryTags.data}
          onDeleteOfferCallback={deleteOffer}
          isEditOffer={!!offerId}
        />
      </LoadingOverlay>
    </>
  );
}

export default CreateOfferContainer;
